<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/ProductStocks'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>หมวดหมู่สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePsProductGroup'"
                    :name="'rePsProductGroup'"
                    :select2-options="rePsProductGroupOptions"
                    multiple
                    v-model="rePsProductGroup"
                  ></select2> -->
                  <treeselect
                    v-model="rePsProductGroup"
                    :multiple="true"
                    :options="rePsProductGroupOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePsProductType'"
                    :name="'rePsProductType'"
                    :select2-options="rePsProductTypeOptions"
                    multiple
                    v-model="rePsProductType"
                  ></select2> -->
                  <treeselect
                    v-model="rePsProductType"
                    :multiple="true"
                    :options="rePsProductTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePsMaterialCode'"
                    :name="'rePsMaterialCode'"
                    :select2-options="rePsMaterialCodeOptions"
                    multiple
                    v-model="rePsMaterialCode"
                  ></select2> -->
                  <treeselect
                    v-model="rePsMaterialCode"
                    :multiple="true"
                    :options="rePsMaterialCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <treeselect
                    v-model="rePsStatus"
                    :multiple="true"
                    :options="rePsStatusOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                  <!--<select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePsStatus'"
                    :name="'rePsStatus'"
                    :select2-options="rePsStatusOptions"
                    multiple
                    v-model="rePsStatus"
                    ref="rePsStatus"
                  ></select2>-->
                </div>
              </div>

              <!-- <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePsStatus'"
                    :name="'rePsStatus'"
                    :select2-options="rePsStatusOptions"
                    multiple
                    v-model="rePsStatus"
                    ref="rePsStatus"
                  ></select2>
                </div>
              </div> -->

              <div
                v-if="this.$root.canShow(['BR_REPORT']) && reViewPermissionCode == 'AGENT_REPORT'"
                class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label>คลัง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePsPlantCode'"
                    :name="'rePsPlantCode'"
                    :select2-options="rePsPlantCodeOptions"
                    multiple
                    v-model="rePsPlantCode"
                  ></select2> -->
                  <treeselect
                    v-model="rePsPlantCode"
                    :multiple="true"
                    :options="rePsPlantCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div
                v-if="this.$root.canShow(['AGENT_REPORT']) && reViewPermissionCode == 'AGENT_REPORT'"
                class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePsAgentCode'"
                    :name="'rePsAgentCode'"
                    :select2-options="rePsAgentCodeOptions"
                    multiple
                    v-model="rePsAgentCode"
                  ></select2> -->
                  <treeselect
                    v-model="rePsAgentCode"
                    :multiple="true"
                    :options="rePsAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div
                v-if="this.$root.canShow(['BR_REPORT']) && reViewPermissionCode == 'AGENT_REPORT'"
                class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label>พนักงาน:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePsForUserId'"
                    :name="'rePsForUserId'"
                    :select2-options="rePsForUserIdOptions"
                    multiple
                    v-model="rePsForUserId"
                  ></select2> -->
                  <treeselect
                    v-model="rePsForUserId"
                    :multiple="true"
                    :options="rePsForUserIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  <treeselect
                    id="reShop"
                    v-model="reShop"
                    :async="true"
                    :multiple="true"
                    :load-options="LoadShopOptions"
                    v-on:open="reLoadShopOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="reShop"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>มุมมองผู้ใช้งาน:</label>
                  <treeselect id="reViewPermissionCode" 
                    v-model="reViewPermissionCode" 
                    :multiple="false" 
                    :options="reViewPermissionOptions"
                    :clear-on-select="true" 
                    placeholder="กรุณาเลือก" 
                    @input="ChangeOptions('View')" />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportProductStock"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive" style="min-width: 1200px;">
              <table
                id="productStockTable"
                class="table-sm table-striped- table-bordered table-hover table-checkable display"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="15">
                      ข้อมูล ณ วันที่ {{ rePsDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center" width="15%">สถานที่</th>
                    <th class="all text-center">หมวดหมู่สินค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th
                      class="all text-center"
                      style="background-color:#FFD700; color:#000000"
                    >
                      SINGHA
                    </th>
                    <th
                      class="all text-center"
                      style="background-color:#D80505;color:#000000"
                    >
                      LEO
                    </th>
                    <th
                      class="all text-center"
                      style="background-color:#808080;color:#000000"
                    >
                      ASAHI
                    </th>
                    <th
                      class="all text-center"
                      style="background-color:#0E853B;color:#000000"
                    >
                      CB
                    </th>
                    <th
                      class="all text-center"
                      style="background-color:#8EA9DB;color:#000000"
                    >
                      KB
                    </th>
                    <th
                      class="all text-center"
                      style="background-color:#C65911;color:#000000"
                    >
                      KOPPER
                    </th>
                    <th
                      class="all text-center"
                      style="background-color:#FCE4D6;color:#000000"
                    >
                      SNOWY
                    </th>
                    <th
                      class="all text-center"
                      style="background-color:#E8AFFF;color:#000000"
                    >
                      FULL MOON
                    </th>
                    <th
                      class="all text-center"
                      style="background-color:#00B0F0;color:#000000"
                    >
                      OTHER
                    </th>
                    <th class="all text-center">Grand Total</th>
                  </tr>
                </thead>
                <!-- <tbody>
    
                       <tr v-for="(row, i) in rePsData" :key="i">
                        <td class="text-center" >{{row.locationName}}</td>
                        <td class="text-center">{{row.productGroupName}}</td>
                        <td class="text-center">{{row.productTypeName}}</td>
                        <td class="text-center">{{row.materialCode}}</td>
                        <td class="text-center">{{row.materialName}}</td>
                        <td class="text-center">{{row.singha}}</td>
                        <td class="text-center">{{row.leo}}</td>
                        <td class="text-center">{{row.asahi}}</td>
                        <td class="text-center">{{row.carlsberg}}</td>
                        <td class="text-center">{{row.kronenbourg}}</td>
                        <td class="text-center">{{row.kopper}}</td>
                        <td class="text-center">{{row.snowy}}</td>
                        <td class="text-center">{{row.fullMoon}}</td>
                        <td class="text-center">{{row.other}}</td>
                        <td v-if="row.grandTotal == 0 && !row.locationName.includes('Total') && !row.productGroupName.includes('Total') && !row.productTypeName.includes('Total')" class="text-center" style="color:#FF0000" >สต๊อกหมด</td>
                        <td v-else-if="row.grandTotal < 0 && !row.locationName.includes('Total') && !row.productGroupName.includes('Total') && !row.productTypeName.includes('Total')" class="text-center" style="background-color:#FF0000;color:#FFFFFF">{{row.grandTotal}}</td>
                        <td v-else class="text-center">{{row.grandTotal}}</td>
                        
                      </tr> 
                  </tbody> -->
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      rePsIsInitial: true,
      rePsDateReq: null,
      rePsProductGroup: [],
      rePsProductType: [],
      rePsMaterialCode: [],
      rePsStatus: [],
      rePsPlantCode: [],
      rePsAgentCode: [],
      rePsForUserId: [],
      rePsData: [],

      rePsStatusOptions: [],

      // rePsStatusOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   //allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       console.log("rePsStatusOptions");
      //       console.log(data.results);
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsPlantCodeOptions: [],
      // rePsPlantCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกคลัง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2Plant",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         plantId: [],
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsAgentCodeOptions: [],
      // rePsAgentCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: null,
      //         province_id: null,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsForUserIdOptions: [],
      // rePsForUserIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกพนักงาน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2PlantForUser",
      //     data: function(params) {
      //       var query = {
      //         isForUSer: true,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsProductGroupOptions: [],
      // rePsProductGroupOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsProductTypeOptions: [],
      // rePsProductTypeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsMaterialCodeOptions: [],
      // rePsMaterialCodeOptions: {
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reShop: [],
      reShopOptions: [],
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.rePsProductGroup = [];
      self.rePsProductType = [];
      self.rePsMaterialCode = [];
      self.rePsStatus = [];
      self.rePsPlantCode = [];
      self.rePsAgentCode = [];
      self.rePsForUserId = [];
      self.reShop = [];

      $("#rePsProductGroup")
        .val("")
        .trigger("change");

      $("#rePsProductType")
        .val("")
        .trigger("change");

      $("#rePsMaterialCode")
        .val("")
        .trigger("change");

      $("#rePsStatus")
      .val("")
      .trigger("change");

      $("#rePsPlantCode")
        .val("")
        .trigger("change");

      $("#rePsAgentCode")
        .val("")
        .trigger("change");

      $("#rePsForUserId")
        .val("")
        .trigger("change");

      $("#reShop")
        .val("")
        .trigger("change");

      self.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#productStockTable").DataTable();
      table.draw();

      // KTApp.blockPage({
      //       opacity: 0.05,
      //       message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      // });

      // axios({
      // method: "post",
      // url: "/Api/Report/ProductStocks",
      // responseType: "application/json",
      // data: {
      //   ProductGroupId : self.rePsProductGroup,
      //   ProductTypeId : self.rePsProductType,
      //   MaterialCode : self.rePsMaterialCode,
      //   StatusCode : self.rePsStatus,
      //   PlantCode : self.rePsPlantCode,
      //   AgentCode :self.rePsAgentCode, //["1000001"],
      //   PlantUserId : self.rePsForUserId
      //   }
      // }).then(function(response) {
      //   if(response.status == "200"){
      //     self.rePsData = response.data.data;

      //     setTimeout(function() {

      //       var table = $("#productStockTable");
      //     var rows = table.find($("tr"));

      //     var colsLength = 3;//$(rows[0]).find($("td")).length;
      //     var removeLater = new Array();
      //     for(var i=0; i<colsLength; i++){
      //         var startIndex = 0;
      //         var lastIndex = 0;
      //         var startText = $($(rows[0]).find("td")[i]).text();
      //         //console.log($($(rows[0]).find("td")[i]));
      //         for(var j=1; j<rows.length; j++){
      //             var cRow =$(rows[j]);
      //             var cCol = $(cRow.find("td")[i]);
      //             var currentText = cCol.text();

      //             if(currentText==startText ){
      //                 removeLater.push(cCol);
      //                 lastIndex=j;
      //             }
      //             else{
      //                 var spanLength = lastIndex-startIndex;
      //                 if(spanLength>=1){
      //                     //console.log(lastIndex+" - "+startIndex)
      //                     //console.log($($(rows[startIndex]).find("td")[i]))
      //                     $($(rows[startIndex]).find("td")[i]).attr("rowspan",spanLength+1);
      //                 }

      //                 lastIndex = j;
      //                 startIndex = j;
      //                 startText = currentText;
      //             }

      //             //Set Row Total text bold
      //             if(startText.includes("Total")){
      //               $(rows[startIndex]).css('font-weight', 'bold');
      //             }
      //             if(i == 0 && startText.includes("Total")){
      //                 $(rows[startIndex]).css('background-color', '#bdd7ee');
      //                 $(rows[startIndex]).css('color', '#000000');
      //                 $(rows[startIndex]).find("td:eq(2)").text(' ');
      //                 $(rows[startIndex]).find("td:eq(1)").text(' ');
      //               }

      //              else if(i == 1 && startText.includes("Total")){
      //                 $(rows[startIndex]).css('background-color', '#F4B084');
      //                 $(rows[startIndex]).css('color', '#000000');
      //               }

      //              else if(i == 2 && startText.includes("Total")){
      //                 $(rows[startIndex]).css('background-color', '#FFF2CC');
      //                 $(rows[startIndex]).css('color', '#000000');
      //               }

      //         }

      //         //$(rows[lastIndex]).eq(i).before('<tr><td style="background-color:#bdd7ee ; color:#000000"><h5>' + startText + " Total " +'</h5></td></tr>');
      //         var spanLength = lastIndex-startIndex;
      //         if(spanLength>=1){
      //           //console.log(lastIndex+" - "+startIndex)
      //           //console.log($($(rows[startIndex]).find("td")[i]))
      //           $($(rows[startIndex]).find("td")[i]).attr("rowspan",spanLength+1);
      //           //$($(rows[startIndex]).find("td")[i]).before('<tr><td style="background-color:#bdd7ee ; color:#000000"><h5>' + startText + " Total " +'</h5></td></tr>');
      //         }

      //     }
      //     for(var i in removeLater){

      //         $(removeLater[i]).remove();
      //     }

      //     }, 50);

      //   }
      // }).catch(function(error) {
      //   Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      // }).then(function() {
      //   //self.formReset();
      //   KTApp.unblockPage();
      // });
    },
    exportProductStock: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportProductStocks",
        responseType: "arraybuffer",
        data: {
          ProductGroupId: self.rePsProductGroup,
          ProductTypeId: self.rePsProductType,
          MaterialCode: self.rePsMaterialCode,
          StatusCode: self.rePsStatus,
          PlantCode: self.rePsPlantCode,
          AgentCode: self.rePsAgentCode,
          PlantUserId: self.rePsForUserId,
          ViewPermissionCode: self.reViewPermissionCode,
          ShopCode: self.reShop,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadrePsPlantCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Plant/Select2Plant", {
          plantId: [],
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePsPlantCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePsAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchAgentName", {
          department: null,
          province_id: null,
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePsAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePsForUserIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Plant/Select2PlantForUser", {
          params: {
            isForUSer: true,
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePsForUserIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePsProductGroupOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePsProductGroupOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePsProductTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePsProductTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePsMaterialCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePsMaterialCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePsStatusOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePsStatusOptions.push({
                id: element.id,
                label: element.text,
              });
            });
            self.rePsStatus = ['PRODUCT_BARCODE_STATUS_READY'];
          }
        })
        .catch(function(error) {});
    },
    async LoadreViewJobRetrieveOptions() {
      var self = this;
      await axios
        .get("/Api/Report/Select2ViewJobRetrieve", {})
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reViewPermissionOptions.push({
                id: element.id,
                label: element.text,
              });

              if (element.data == "active") {
                self.reViewPermissionCode = element.id;
              }
            });
          }
        })
        .catch(function (error) { });
    },
    ChangeOptions(type) {
      console.log("ChangeOptions");
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formReset();
        }
      }
    },
    LoadShopOptions({ action, searchQuery, callback }) {
      var self = this;
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Report/Select2SubAgentStock", {
            page: 1,
            all: true,
            search: searchQuery
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reShopOptions = [];
              data.forEach((element) => {
                self.reShopOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }

            callback(null, self.reShopOptions);
          })
          .catch(function(error) {});
      }
    },
    reLoadShopOptions: function(){
      this.$refs.reShop.trigger.searchQuery = null
    },
    ClearAfterselect: function() {
      $(`[class="vue-treeselect__input"]`).val("");
    },
  },
  async mounted() {
    let self = this;

    self.LoadrePsPlantCodeOptions();
    self.LoadrePsAgentCodeOptions();
    self.LoadrePsForUserIdOptions();
    self.LoadrePsProductGroupOptions();
    self.LoadrePsProductTypeOptions();
    self.LoadrePsMaterialCodeOptions();
    self.LoadrePsStatusOptions();
    // self.$refs.rePsStatus.setSelectedData([
    //   { id: "PRODUCT_BARCODE_STATUS_READY", text: "พร้อมใช้งาน" }
    // ]);
    await self.LoadreViewJobRetrieveOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.rePsDateReq = moment().format("DD/MM/YYYY h:mm a");
    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#productStockTable");
    //begin first table
    table
      .DataTable({
        paging: false,
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/ProductStocks",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              IsInitial: self.rePsIsInitial,
              ProductGroupId: self.rePsProductGroup,
              ProductTypeId: self.rePsProductType,
              MaterialCode: self.rePsMaterialCode,
              StatusCode: self.rePsStatus,
              PlantCode: self.rePsPlantCode,
              AgentCode: self.rePsAgentCode,
              PlantUserId: self.rePsForUserId,
              ViewPermissionCode: self.reViewPermissionCode,
              ShopCode: self.reShop,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        //orderFixed: [[0, 'asc'],[1, 'asc'],[2, 'asc'],[3, 'asc']],
        order: [[0, "desc"]],
        columns: [
          {
            data: "locationName",
            className: "text-center",
            orderable: false,
            width: "10%",
          },
          {
            data: "productGroupName",
            className: "text-center",
            orderable: false,
            width: "10%",
          },
          {
            data: "productTypeName",
            className: "text-center",
            orderable: false,
            width: "10%",
          },
          {
            data: "materialCode",
            className: "text-center",
            orderable: false,
            width: "5%",
          },
          {
            data: "materialName",
            className: "text-center",
            orderable: false,
            width: "15%",
          },
          {
            data: "singha",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "leo",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "asahi",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "carlsberg",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "kronenbourg",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "kopper",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "snowy",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "fullMoon",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "other",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (data == 0) {
                return "-";
              } else {
                return self.$options.filters.currency(data, "", 0);
              }
            },
          },
          {
            data: "grandTotal",
            className: "text-center",
            orderable: false,
            width: "5%",
            render: function(data, type, full, meta) {
              if (
                data == 0 &&
                !full.locationName.includes("Total") &&
                !full.productGroupName.includes("Total") &&
                !full.productTypeName.includes("Total")
              ) {
                return '<span class="text-danger"> สต๊อกหมด</span>';
              } else {
                if (data == 0) {
                  return "-";
                } else {
                  return self.$options.filters.currency(data, "", 0);
                }
              }
            },
          },
        ],
        rowCallback: function(row, data, index) {
          if (
            data.grandTotal < 0 &&
            !data.locationName.includes("Total") &&
            !data.productGroupName.includes("Total") &&
            !data.productTypeName.includes("Total")
          ) {
            $(row)
              .find("td:eq(14)")
              .css("color", "white");
            $(row)
              .find("td:eq(14)")
              .css("background-color", "#EB355E");
          } else if (data.grandTotal < 0) {
            $(row)
              .find("td:eq(14)")
              .css("color", "#EB355E");
          }

          // if (data.grandTotal < 0 && (data.locationName.includes("Total") || data.productGroupName.includes("Total") || data.productTypeName.includes("Total"))) {
          //   $(row).find("td:eq(13)").css("color", "#EB355E");
          // }

          if (data.other < 0) {
            $(row)
              .find("td:eq(13)")
              .css("color", "#EB355E");
          }

          if (data.fullMoon < 0) {
            $(row)
              .find("td:eq(12)")
              .css("color", "#EB355E");
          }

          if (data.snowy < 0) {
            $(row)
              .find("td:eq(11)")
              .css("color", "#EB355E");
          }

          if (data.kopper < 0) {
            $(row)
              .find("td:eq(10)")
              .css("color", "#EB355E");
          }

          if (data.kronenbourg < 0) {
            $(row)
              .find("td:eq(9)")
              .css("color", "#EB355E");
          }

          if (data.carlsberg < 0) {
            $(row)
              .find("td:eq(8)")
              .css("color", "#EB355E");
          }

          if (data.asahi < 0) {
            $(row)
              .find("td:eq(7)")
              .css("color", "#EB355E");
          }

          if (data.leo < 0) {
            $(row)
              .find("td:eq(6)")
              .css("color", "#EB355E");
          }

          if (data.singha < 0) {
            $(row)
              .find("td:eq(5)")
              .css("color", "#EB355E");
          }

          if (data.locationName.includes("Total")) {
            // $(row)
            //   .find("td:eq(0)").sty
          }
        },
        drawCallback: function(settings) {
          self.rePsIsInitial = false;
          self.rePsDateReq = moment().format("DD/MM/YYYY h:mm a");

          if (settings.json.data.length === 0) {
            return false;
          }

          var table = $("#productStockTable");
          var rows = table.find($("tr"));

          var colsLength = 3; //$(rows[0]).find($("td")).length;
          var removeLater = new Array();
          for (var i = 0; i < colsLength; i++) {
            var startIndex = 0;
            var lastIndex = 0;
            var startText = $($(rows[0]).find("td")[i]).text();
            //console.log($($(rows[0]).find("td")[i]));
            for (var j = 1; j < rows.length; j++) {
              var cRow = $(rows[j]);
              var cCol = $(cRow.find("td")[i]);
              var currentText = cCol.text();

              if (currentText == startText) {
                removeLater.push(cCol);
                lastIndex = j;
              } else {
                var spanLength = lastIndex - startIndex;
                if (spanLength >= 1) {
                  //console.log(lastIndex+" - "+startIndex)
                  //console.log($($(rows[startIndex]).find("td")[i]))
                  $($(rows[startIndex]).find("td")[i]).attr(
                    "rowspan",
                    spanLength + 1
                  );
                }

                lastIndex = j;
                startIndex = j;
                startText = currentText;
              }

              //Set Row Total text bold
              if (startText.includes("Total")) {
                $(rows[startIndex]).css("font-weight", "bold");
              }
              if (i == 0 && startText.includes("Total")) {
                $(rows[startIndex]).css("background-color", "#bdd7ee");
                $(rows[startIndex]).css("color", "#000000");
                //$(rows[startIndex]).find("td:eq(0)").attr("colspan",3);
                $(rows[startIndex])
                  .find("td:eq(2)")
                  .text(" ");
                $(rows[startIndex])
                  .find("td:eq(1)")
                  .text(" ");
              } else if (i == 1 && startText.includes("Total")) {
                $(rows[startIndex]).css("background-color", "#F4B084");
                $(rows[startIndex]).css("color", "#000000");
              } else if (i == 2 && startText.includes("Total")) {
                $(rows[startIndex]).css("background-color", "#FFF2CC");
                $(rows[startIndex]).css("color", "#000000");
              }
            }

            //$(rows[lastIndex]).eq(i).before('<tr><td style="background-color:#bdd7ee ; color:#000000"><h5>' + startText + " Total " +'</h5></td></tr>');
            var spanLength = lastIndex - startIndex;
            if (spanLength >= 1) {
              //console.log(lastIndex+" - "+startIndex)
              //console.log($($(rows[startIndex]).find("td")[i]))
              $($(rows[startIndex]).find("td")[i]).attr(
                "rowspan",
                spanLength + 1
              );
              //$($(rows[startIndex]).find("td")[i]).before('<tr><td style="background-color:#bdd7ee ; color:#000000"><h5>' + startText + " Total " +'</h5></td></tr>');
            }
          }
          for (var i in removeLater) {
            $(removeLater[i]).remove();
          }
        },
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/ProductStocks.vue